$(document).on('click', '#outreach_messages .copy-image_file_show_url, .show-outreach-message .copy-image_file_show_url', function() {
  let txt = $(this).closest('tr').find('.text-image_file_show_url').text();
  navigator.clipboard.writeText(txt).then(() => {
    // alert('It worked! Do a CTRL - V to paste');
    $(this).closest('tr').find('.msg').html('Success: Copied').removeClass('text-danger').addClass('text-success').show('slow');
    setTimeout(() => { $(this).closest('tr').find('.msg').hide('slow'); }, 3000);
  }, function () {
    // alert('Failure to copy. Check permissions for clipboard');
    $(this).closest('tr').find('.msg').html('Error: can not copy').removeClass('text-success').addClass('text-danger').show('slow');
    setTimeout(() => { $(this).closest('tr').find('.msg').hide('slow'); }, 3000);
  });
});
